function CurrencyUtils() {
}

CurrencyUtils.prototype.currency = (num) => {
  try {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
  catch(e) {
    return (0).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
}

CurrencyUtils.prototype.commaFormat = (num) => {
  return num ? Number((num).toFixed(1)).toLocaleString() : num;
}

export default new CurrencyUtils();